import {
  IconTick,
  IconPromote,
  Columns,
  Column,
  Text,
} from 'braid-design-system';
import type React from 'react';

type TextWithIconProps = React.ComponentProps<typeof Text> & {
  iconType: React.ReactElement;
};

// TODO use List component with icon instead of Column
const TextWithIcon: React.FC<React.PropsWithChildren<TextWithIconProps>> = (
  props,
) => (
  <Columns space="xsmall">
    <Column width="content">{props.iconType}</Column>
    <Column>
      <Text {...props}>{props.children}</Text>
    </Column>
  </Columns>
);

const IconTickText: React.FC<
  React.PropsWithChildren<React.ComponentProps<typeof Text>>
> = (props) => (
  <TextWithIcon {...props} iconType={<IconTick size="xsmall" tone="link" />} />
);

const IconPromoteText: React.FC<
  React.PropsWithChildren<React.ComponentProps<typeof Text>>
> = (props) => (
  <TextWithIcon
    {...props}
    iconType={<IconPromote size="xsmall" tone="link" />}
  />
);

export { IconTickText, IconPromoteText };
